import { PilotDoc } from '../../../../../types';

export function getThumbnail(doc?: PilotDoc) {
  const attachment = doc?.attachments?.[0];

  return attachment
    ? {
        filename: attachment.filename,
        url: attachment.thumbnails?.large.url,
      }
    : undefined;
}
